var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _g2, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoTv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 339,
    height: 80,
    viewBox: "0 0 339 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8497 0H0V20.4503H19.8497V0Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8497 30.0771H0V79.9999H19.8497V30.0771Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80 0H30.0762V20.4503H80V0Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9259 30.0771H30.0762V79.9999H49.9259V30.0771Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0059 30.0771H60.1562V79.9999H80.0059V30.0771Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6088_51201",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 258,
    y: 0,
    width: 81,
    height: 80
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M338.002 0.401367H258.004V79.9969H338.002V0.401367Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6088_51201)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288.204 24.7278C293.09 24.7278 297.05 19.2821 297.05 12.5646C297.05 5.84701 293.09 0.401367 288.204 0.401367C283.319 0.401367 279.359 5.84701 279.359 12.5646C279.359 19.2821 283.319 24.7278 288.204 24.7278Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.394 24.215C320.259 24.2896 316.184 29.1499 316.299 36.6766C316.409 44.2034 320.659 47.631 325.794 47.5563C330.924 47.4817 334.999 43.9298 334.889 36.403C334.744 26.6028 326.624 24.1951 325.394 24.215Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.117 43C276.142 42.6501 279.83 36.8803 279.354 30.1127C278.878 23.345 274.418 18.1424 269.393 18.4922C264.368 18.842 260.681 24.6118 261.157 31.3795C261.633 38.1471 266.092 43.3498 271.117 43Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.694 52.4713C316.299 48.6258 312.569 45.4967 306.739 37.4327C303.849 33.4479 300.524 32.9355 297.045 32.9355C293.56 32.9355 289.89 34.1544 287.07 38.1839C284.25 42.2134 281.05 46.1534 274.835 51.3122C268.625 56.471 265.99 60.0329 265.99 65.2812C265.99 70.5295 269 79.2502 277.565 79.2502C286.13 79.2502 290.27 77.3748 297.045 77.3748C303.819 77.3748 308.334 79.9964 316.899 79.9964C325.464 79.9964 329.039 71.9324 329.039 66.6841C329.039 61.4357 327.554 58.4609 320.694 52.4713Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6088_51201",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 295,
    y: 0,
    width: 33,
    height: 33
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M327.928 9.71891L304.916 0L295.148 22.8963L318.16 32.6152L327.928 9.71891Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6088_51201)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M321.315 8.43012L321.275 8.41305C318.307 7.15972 315.726 8.61982 314.333 9.758C314.175 7.96461 313.451 5.1088 310.484 3.85546L310.43 3.83271C307.208 2.50366 303.37 4.09809 301.736 7.47903C299.73 11.6212 301.907 15.8985 305.147 22.3354C305.703 23.4573 306.296 24.6423 306.92 25.9037L307.199 26.4809L307.81 26.2798C309.142 25.8444 310.424 25.4513 311.622 25.07C318.526 22.9172 323.13 21.5038 324.731 17.1906C326.041 13.6729 324.514 9.81285 321.315 8.43012Z",
    fill: "#FF3636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.731 17.1918C323.13 21.5049 318.525 22.9183 311.621 25.0711C310.424 25.4524 309.142 25.8455 307.81 26.2809L307.199 26.4821L314.333 9.75912C315.726 8.62091 318.307 7.16084 321.275 8.41418L321.315 8.43125C324.514 9.814 326.041 13.6741 324.731 17.1918Z",
    fill: "#F40000"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M144.006 15L194.005 64.9979M194.005 15L144.006 64.9979",
    stroke: "black",
    strokeWidth: 7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTv);
export default __webpack_public_path__ + "static/media/Logo_tv.19065e278f42bef46d147f017311855f.svg";
export { ForwardRef as ReactComponent };